export default {
  methods: {
    notifyError(message, title = 'An error has occurred') {
      this.$vs.notify({
        color: 'danger',
        title: title,
        text: message,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        position: 'top-right'
      });
    },
    notifySuccess(message, title = 'Success') {
      this.$vs.notify({
        color: 'success',
        title: title,
        text: message,
        iconPack: 'feather',
        position: 'top-right'
      });
    },
  },
};
